import React from "react";
import BalanceTable from "./BalanceTable";

const Withdrawals = ({ withdrawals }) => {
  const columns = [
    "Gross Amount",
    "Platform Fee (21%)",
    "Net Payout",
    "Status",
    "Date",
  ];

  return (
    <>
      {withdrawals?.length > 0 ? (
        <BalanceTable columns={columns} data={withdrawals} type="Withdrawals" />
      ) : (
        <p>No Withdrawals</p>
      )}
    </>
  );
};

export default Withdrawals;
